import { createTheme } from '@mui/material/styles';

export const customTheme = {
  palette: {
    background: {
      default: '#F1F0ED'
    }
  }
};

const fontFamily = '"Segoe UI", Inter, Arial, sans-serif';

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#28334A', //Basic dploy blue
      light: '#4D4D4D',
      dark: '#000000' //Black
    },
    secondary: {
      main: '#FFFFFF',
      light: '#FBFBFA',
      dark: '#E3E2DE'
    },
    background: {
      default: '#F5F5F3',
      paper: '#FFFFFF'
    },
    divider: '#E3E2DE',
    success: {
      main: '#5DD570',
      light: '#DBEEDE',
      dark: '#00594F'
    },
    warning: {
      main: '#D3882F'
    },
    error: {
      main: '#D32F2F'
    }
  },
  shape: {
    borderRadius: 6
  },
  typography: {
    fontFamily,
    // Base size drives MUI's rem scaling for inputs, labels, chips etc.
    fontSize: 12,
    h1: { fontFamily, fontSize: 14, fontWeight: '600', lineHeight: 1.3 },
    h2: { fontFamily, fontSize: 14, fontWeight: '700', lineHeight: 1.3 },
    h3: { fontFamily, fontSize: 14, fontWeight: '700', lineHeight: 1.3 },
    h4: { fontFamily, fontSize: 13, fontWeight: '600', lineHeight: 1.3 },
    h5: { fontFamily, fontSize: 12, fontWeight: '600', lineHeight: 1.3 },
    h6: { fontFamily, fontSize: 12, fontWeight: '600', lineHeight: 1.3 },
    subtitle1: { fontFamily, fontSize: 12, fontWeight: '600', lineHeight: 1.35 },
    subtitle2: { fontFamily, fontSize: 11, fontWeight: '600', lineHeight: 1.35 },
    body1: { fontFamily, fontSize: 12, fontWeight: '400', lineHeight: 1.4 },
    body2: { fontFamily, fontSize: 12, fontWeight: '400', lineHeight: 1.35 },
    caption: { fontFamily, fontSize: 11, fontWeight: '400', lineHeight: 1.3 },
    button: { fontFamily, fontSize: 12, fontWeight: 600, textTransform: 'none', lineHeight: 1.5 }
  },
  spacing: 6,
  components: {
    MuiButton: {
      defaultProps: { size: 'small', disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, fontFamily, minWidth: 0 },
        sizeSmall: { padding: '2px 10px', fontSize: 12 },
        outlined: { backgroundColor: '#fff' }
      }
    },
    MuiIconButton: { defaultProps: { size: 'small' } },
    MuiSvgIcon: { defaultProps: { fontSize: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small', margin: 'none' } },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: { backgroundColor: '#fff', fontSize: 12 },
        inputSizeSmall: { paddingTop: 5, paddingBottom: 5 },
        notchedOutline: {
          fontWeight: 'bold' // Set the <legend> on a <fieldset> bold, so the border doesn't overlap the bold legend
        }
      }
    },
    MuiInputLabel: {
      defaultProps: { size: 'small' },
      styleOverrides: { root: { fontSize: 12, fontWeight: 'bold' } }
    },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiChip: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: { fontSize: 12, height: 26 },
        icon: { width: 16, height: 16 }
      }
    },
    MuiList: { defaultProps: { dense: true } },
    MuiListItem: { defaultProps: { dense: true } },
    MuiListItemButton: { defaultProps: { dense: true } },
    MuiListItemIcon: { styleOverrides: { root: { minWidth: 28 } } },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 1,
          marginBottom: 1,
          minWidth: 0,
          // Listings pass a Typography as primary/secondary, which bypasses noWrap.
          '& > .MuiTypography-root': {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }
      }
    },
    MuiMenuItem: { defaultProps: { dense: true } },
    MuiToolbar: { defaultProps: { variant: 'dense' } },
    MuiTooltip: { styleOverrides: { tooltip: { fontSize: 11 } } },
    MuiAccordionSummary: {
      styleOverrides: {
        root: { minHeight: 36, '&.Mui-expanded': { minHeight: 36 } },
        content: { margin: '6px 0', '&.Mui-expanded': { margin: '6px 0' } }
      }
    },
    MuiAccordionDetails: { styleOverrides: { root: { padding: '4px 12px 12px' } } },
    MuiPaper: { defaultProps: { elevation: 0 } },
    MuiAccordion: { defaultProps: { elevation: 0 } }
  }
});
